var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.82353H20.8667M11.3333 5H16.5333M12.2 17.2353V11.5882M15.6667 17.2353V11.5882M16.9667 21H10.9C9.94271 21 9.16667 20.1572 9.16667 19.1176L8.77095 8.80389C8.75043 8.26918 9.14406 7.82353 9.63686 7.82353H18.2298C18.7226 7.82353 19.1162 8.26918 19.0957 8.80389L18.7 19.1176C18.7 20.1572 17.924 21 16.9667 21Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionTrash);
export default __webpack_public_path__ + "static/media/action-trash.a8e6d32811159ce948c50d7b9f33abdf.svg";
export { ForwardRef as ReactComponent };